import React, { useState } from 'react';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';
import { DemoFormFeedback } from '../components/DemoFormFeedback';
import { usePublicFormSubmit } from '../hooks/usePublicFormSubmit';

const WAITLIST_TOPIC = 'Upcoming product waitlist';

export default function UpcomingPage() {
  const [email, setEmail] = useState('');
  const { status, runSubmit, isSubmitting } = usePublicFormSubmit();

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const ok = await runSubmit('/public/support', {
      name: 'Waitlist',
      email,
      topic: WAITLIST_TOPIC,
      message: 'Interested in early access to the upcoming product.',
    });
    if (ok) setEmail('');
  };

  return (
    <PublicPageLayout
      title='Upcoming Product'
      subtitle='Join the waitlist to get early access to our next product release.'
    >
      <p className='text-gray-700 dark:text-gray-200'>
        We are building a deeper optimization workspace for teams that need advanced pricing simulations, scenario planning,
        and launch controls.
      </p>
      <form
        onSubmit={onSubmit}
        className='max-w-xl space-y-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm ring-1 ring-gray-900/5'
      >
        <div>
          <label htmlFor='waitlist-email' className='mb-2 block text-sm font-medium text-gray-700'>
            Work email
          </label>
          <input
            id='waitlist-email'
            type='email'
            required
            autoComplete='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-900 placeholder-gray-500 focus:border-yellow-500 focus:outline-none focus:ring-1 focus:ring-yellow-500'
            placeholder='you@company.com'
          />
        </div>
        <button
          type='submit'
          disabled={isSubmitting}
          className='rounded-md bg-yellow-500 px-4 py-2 text-sm font-semibold text-white hover:bg-yellow-600 disabled:cursor-not-allowed disabled:opacity-70'
        >
          {isSubmitting ? 'Joining...' : 'Join Waitlist'}
        </button>
        <DemoFormFeedback
          tone='light'
          status={status}
          successMessage='Thanks. You are on the waitlist—we will follow up at the email you provided.'
          errorMessage='Something went wrong. Please try again or email us directly.'
        />
      </form>
    </PublicPageLayout>
  );
}
